export default "__VITE_ASSET__6a87bbbd__"